<template>
  <div>
    <transition :name="routerTransition" mode="out-in" v-if="isLoaded">
      <div >
        <esp-header :dataPage="dataPage" ref="espHeader" v-if="isLoaded"></esp-header>
        <router-view :dataPage="dataPage" v-if="isLoaded"  />
        <esp-footer :dataPage="dataPage" ref="espFooter" v-if="isLoaded"></esp-footer>
      </div>
    </transition>
  </div>
</template>
<script>
import Vue from 'vue'

// FIREBASE
import "firebase/auth";
const firebase = require("firebase");
require("firebase/firestore");
require("firebase/auth");
var db = firebase.firestore();

// CONFIG
import  { themeConfig, irisConfig }  from "@/../siteConfig.js";

// IMPORT ZONES HEADER AND FOOTER
import EspHeader from "@/layouts/Header.vue"
import EspFooter from "@/layouts/Footer.vue";

export default {
  components: {
    EspHeader,
    EspFooter
  },
  data() {
    return {
      routerTransition: themeConfig.routerTransition || "none",
      everLoad:false,
      irisConfig:irisConfig,
      dataIris:{
        customizableVar:[],
        customizableVarLoaded:false,
        googleAnalyticsID:'',
        menuHeaderRight:{
          itemsMenu:{
            children:[]
          }
        },
        menuHeaderRightLoaded:false,
        menuHeaderLeft:{
          itemsMenu:{
            children:[]
          }
        },
        menuHeaderLeftLoaded:false,

        menuFooter:{
          itemsMenu:{
            children:[]
          }
        },
        menuFooterLoaded:false,

        pages:[],
        pagesLoaded:false,
      },
      dataPage:{
        customizableVar:[
          { 
            value:{
              value: "0f555d"
            }
          }
        ]
      }
    };
  },
  metaInfo() {
    return { 
        title: this.dataPage.metaTitle ? this.dataPage.metaTitle : "Laboratoire ODF Tournier - Fabricant d'appareillages orthodontiques",
        meta: [
            { name: 'description', content: this.dataPage.metaDescription ? this.dataPage.metaDescription : 'Hélène et Jean-Baptiste TOURNIER, gérant du laboratoire d\'orthodontie Tournier, situé à Rouen en Normandie, réalisent tout types d’orthèses dentaires en orthodontie, pédodontie et ODF'},
            { property: 'og:title', content: this.dataPage.metaTitle ? this.dataPage.metaTitle : "Laboratoire ODF Tournier - Fabricant d'appareillages orthodontiques"},
            { property: 'og:site_name', content: 'Laboratoire ODF Tournier'},
            { property: 'og:type', content: 'website'},    
            { name: 'robots', content: 'index,follow'} 
        ]
    }
  },
  beforeMount() {
    this.fetchData();
  },
  watch: {
    $route(to, from) {
      // react to route changes...
      //console.log("Route from : ", from, "Route to : ", to)
      this.getDataPage()
    }
  },
  methods: {
    getCustomizableVar(){
      this.dataIris.customizableVar=[]
      let parentThis = this
      db.collection("customers")
        .doc(this.irisConfig.customers)
        .collection('sites')
        .doc(this.irisConfig.sites)
        .onSnapshot(function(doc) {
          parentThis.dataIris.customizableVar.push(doc.data().customizableVar)
          parentThis.dataIris.customizableVarLoaded=true
          parentThis.dataIris.googleAnalyticsID = doc.data().googleAnalyticsID
          
          //console.log(parentThis.dataIris.googleAnalyticsID) 
        })
    },
    getMenuHeaderRight(){
      this.dataIris.customizableVar=[]
      let parentThis = this
      db.collection("customers")
        .doc(this.irisConfig.customers)
        .collection('sites')
        .doc(this.irisConfig.sites)
        .collection('Menu-Droite_Menu')
        .doc(this.irisConfig.menuHeaderRight)
        .onSnapshot(function(doc) {
          parentThis.dataIris.menuHeaderRight=doc.data()
           parentThis.dataIris.menuHeaderRightLoaded=true
        })
    },
    getMenuHeaderLeft(){
      this.dataIris.customizableVar=[]
      let parentThis = this
      db.collection("customers")
        .doc(this.irisConfig.customers)
        .collection('sites')
        .doc(this.irisConfig.sites)
        .collection('Menu-Gauche_Menu')
        .doc(this.irisConfig.menuHeaderLeft)
        .onSnapshot(function(doc) {
          parentThis.dataIris.menuHeaderLeft=doc.data()
           parentThis.dataIris.menuHeaderLeftLoaded=true
        })
    },
    getMenuFooter(){
      this.dataIris.customizableVar=[]
      let parentThis = this
      db.collection("customers")
        .doc(this.irisConfig.customers)
        .collection('sites')
        .doc(this.irisConfig.sites)
        .collection('Menu-Footer_Menu')
        .doc(this.irisConfig.menuFooter)
        .onSnapshot(function(doc) {
          parentThis.dataIris.menuFooter=doc.data()
           parentThis.dataIris.menuFooterLoaded=true
        })
    },
    getPages(){
      this.dataIris.pages=[]
      let parentThis = this
      db.collection("customers")
        .doc(this.irisConfig.customers)
        .collection('sites')
        .doc(this.irisConfig.sites)
        .collection('pages')
        .onSnapshot(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
              parentThis.dataIris.pages.push(doc.data())
          })
          parentThis.dataIris.pagesLoaded=true
        })
    },
    getDataPage(){
      this.everLoad = true
      if(this.$route.params.id){
        // Recherche par id
        //console.log("recherche par id")
        this.dataPage = this.dataIris.pages.find(page => page.id === this.$route.params.id) 
      }else{
        // Recherche par route
        //console.log("recherche par route")
        this.dataPage = this.dataIris.pages.find(page => page.route === this.$route.params.route) 
      }
    },
    fetchData() {
      this.getCustomizableVar(),
      this.getPages(),
      this.getMenuHeaderLeft()
      this.getMenuHeaderRight()
      this.getMenuFooter()
    }
  },
  computed:{
    isLoaded: function () {
      if(this.dataIris.customizableVarLoaded && this.dataIris.menuHeaderRightLoaded && this.dataIris.menuHeaderLeftLoaded && this.dataIris.menuFooterLoaded && this.dataIris.pagesLoaded ){    
        if(this.everLoad==false){
          this.getDataPage()
        }    
        return true
      }else{
        return false
      }
    }
  }
};
</script>

